export default __webpack_public_path__ + "static/media/trainer_comp2.44e0000b.png";